import { Component, OnInit } from '@angular/core';
import { ViewPortTypes, Globals } from '@transfora/core';
import { LayoutService, LayoutQuery, UserQuery } from '@transfora/admin';
import { Router } from '@angular/router';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit {
  public viewPortTypes: typeof ViewPortTypes = ViewPortTypes;
  constructor(
    public globals: Globals,
    private layoutService: LayoutService,
    public layoutQuery: LayoutQuery,
    private router: Router,
    private userQuery: UserQuery,
  ) {}

  ngOnInit(): void {
    // Side effect of preventing lazyloading a module, if the user is not authenticated
    if (this.router.url === '/') {
      this.router.navigate([this.userQuery.menus[0]?.processName ?? 'home']);
    }
  }

  onSearch(searchText) {
    this.layoutService.update({ searchText });
  }
}
